import './CubesAnim.css';
import { useEffect } from 'react';
import transparentSpan from "../../utils/transparentSpan";

const CubesAnim = () => {
  useEffect(() => { 
      transparentSpan();
  })
  let jsxSpans = [];

  for (let i = 0; i < 420; i++) {
    jsxSpans.push(<span className="cubes" key={i}></span>);
  }

  return <div className="cubes_div">{jsxSpans}</div>;
};

export default CubesAnim;
